module.exports = __webpack_public_path__ + "img/buddy_eyes-06.2892d11c.svg";